var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86791 32.478H28.8891C30.9409 32.478 32.6086 30.832 32.6086 28.8069V6.78031C32.6086 4.75516 30.9409 3.10938 28.8891 3.10938H3.86791C1.81612 3.10938 0.148438 4.75516 0.148438 6.78031V28.8069C0.148438 30.832 1.81612 32.478 3.86791 32.478ZM2.17725 6.78052C2.17725 5.86071 2.93605 5.112 3.86796 5.112H28.8891C29.821 5.112 30.5798 5.86071 30.5798 6.78052V28.8071C30.5798 29.7269 29.821 30.4759 28.8891 30.4759H3.86796C2.93605 30.4759 2.17725 29.7269 2.17725 28.8071V6.78052Z",
    fill: "#46484A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5942 12.3856H1.16282C0.602877 12.3856 0.148438 12.0393 0.148438 11.6127C0.148438 11.1861 0.602877 10.8398 1.16282 10.8398H31.5942C32.1541 10.8398 32.6086 11.1861 32.6086 11.6127C32.6086 12.0393 32.1541 12.3856 31.5942 12.3856Z",
    fill: "#46484A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64981 7.74813C8.22319 7.74813 7.87695 7.31533 7.87695 6.78206V0.985606C7.87695 0.452331 8.22319 0.0195312 8.64981 0.0195312C9.07643 0.0195312 9.42267 0.452331 9.42267 0.985606V6.78206C9.42267 7.31533 9.07643 7.74813 8.64981 7.74813Z",
    fill: "#46484A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1068 7.74813C23.6802 7.74813 23.334 7.31533 23.334 6.78206V0.985606C23.334 0.452331 23.6802 0.0195312 24.1068 0.0195312C24.5335 0.0195312 24.8797 0.452331 24.8797 0.985606V6.78206C24.8797 7.31533 24.5335 7.74813 24.1068 7.74813Z",
    fill: "#46484A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.78809,
    y1: 17.5625,
    x2: 11.4264,
    y2: 17.5625,
    stroke: "#5B4EB5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.6821,
    y1: 17.5625,
    x2: 19.3204,
    y2: 17.5625,
    stroke: "#5B4EB5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5752,
    y1: 17.5625,
    x2: 27.2135,
    y2: 17.5625,
    stroke: "#5B4EB5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 5.78809,
    y1: 20.9453,
    x2: 11.4264,
    y2: 20.9453,
    stroke: "#5B4EB5"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 13.6821,
    y1: 20.9453,
    x2: 19.3204,
    y2: 20.9453,
    stroke: "#5B4EB5"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5752,
    y1: 20.9453,
    x2: 27.2135,
    y2: 20.9453,
    stroke: "#5B4EB5"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 5.78809,
    y1: 24.3281,
    x2: 11.4264,
    y2: 24.3281,
    stroke: "#5B4EB5"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 13.6821,
    y1: 24.3281,
    x2: 19.3204,
    y2: 24.3281,
    stroke: "#5B4EB5"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5752,
    y1: 24.3281,
    x2: 27.2135,
    y2: 24.3281,
    stroke: "#5B4EB5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCalendarIcon);
export default __webpack_public_path__ + "static/media/purpleCalendarIcon.17f014860c359f866657fc030cd7927b.svg";
export { ForwardRef as ReactComponent };